<app-layout>
  @let cities = (cities$ | async) ?? [];
  @let categories = (categories$ | async) ?? [];

  <div class="page-container container">
    <app-events-filter
      [cities]="cities"
      [categories]="categories"
      [initialFilters]="initialFilters"
      (filtersChange)="handleFiltersChange($event)" />

    <app-events-list
      [eventsPage]="eventsList$ | async"
      (pageChangeClick)="handlePageChange($event)"
      [isLoading]="isLoading()" />
  </div>
</app-layout>
